import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

export default function StandardSkeletoon({
  row = 4,
  col = 1,
  show = true,
  height = 30,
  escalier = false,
  m,
  boxHeight=400,
}) {
  return (
    <Grid display={show ? "flex" : "none"} m={m || 0} height={boxHeight}>
      {Array.from({ length: col }).map((_, colIdx) => (
        <Box
          key={colIdx}
          display={show ? "block" : "none"}
          m={0.5}
          width={"100%"}
        >
          {Array.from({ length: row }).map((_, rowIdx) => {
            let width = "100%";
            if (escalier) {
              if (rowIdx === 0) width = "100%";
              else if (rowIdx === 1) width = "75%";
              else width = "50%";
            }
            return (
              <Skeleton
                key={rowIdx}
                animation="pulse"
                height={height}
                width={width}
                style={{ marginBottom: 8 }}
              />
            );
          })}
        </Box>
      ))}
    </Grid>
  );
}
